import { render, staticRenderFns } from "./YellowPlusIcon.vue?vue&type=template&id=7a97b5a2"
import script from "./YellowPlusIcon.vue?vue&type=script&lang=ts"
export * from "./YellowPlusIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports